"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceForUid_DeviceUniqueId_UserType = exports.deviceListForUserId = exports.deviceUpdate = exports.deviceCreate = void 0;
const Device_1 = require("../models/Device");
const firestoreSerialize_1 = __importDefault(require("../models/firebase/firestoreSerialize"));
const PATH = 'devices';
async function deviceCreate(device, database) {
    return await database.create(PATH, (0, firestoreSerialize_1.default)(device));
}
exports.deviceCreate = deviceCreate;
async function deviceUpdate(id, values, database) {
    await database.update(PATH, id, values);
}
exports.deviceUpdate = deviceUpdate;
async function deviceListForUserId(uid, database) {
    const results = await database.list(PATH, {
        orderByChild: 'uid',
        equalTo: uid,
    });
    return results.map(result => (0, Device_1.deviceDeserialize)(result.value, result.id));
}
exports.deviceListForUserId = deviceListForUserId;
async function deviceForUid_DeviceUniqueId_UserType(uid, deviceUniqueId, userType, database) {
    const devices = await deviceListForUserId(uid, database);
    const device = devices.find(device => device.deviceUniqueId === deviceUniqueId && device.userType === userType);
    return device;
}
exports.deviceForUid_DeviceUniqueId_UserType = deviceForUid_DeviceUniqueId_UserType;
